import { useEffect } from "react";
import CommonAuthLayout from "./Auth/CommonAuthLayout";
import { Loading, Typography } from "../components/common";

const APP_HOME_URL =
  process.env.REACT_APP_APP_HOME_URL || "https://app.pedagogue.io";

const buildOtpRedirectUrl = () => {
  const query = new URLSearchParams(window.location.search);
  const email = query.get("email");

  if (email) {
    const welcomeUrl = new URL("/welcome", APP_HOME_URL);
    welcomeUrl.searchParams.set("email", email.trim().toLowerCase());
    welcomeUrl.searchParams.set("plan", "PREMIUM");
    return welcomeUrl.toString();
  }

  return new URL("/login", APP_HOME_URL).toString();
};

const ResetPassword = () => {
  useEffect(() => {
    window.location.replace(buildOtpRedirectUrl());
  }, []);

  const handleNavigateToLogin = () => {
    window.location.href = new URL("/login", APP_HOME_URL).toString();
  };

  return (
    <CommonAuthLayout isLogin={false} onNavigate={handleNavigateToLogin}>
      <div className="max-w-[464px] mx-auto sm:p-6 pt-2 bg-white rounded-lg flex flex-col gap-4 items-center">
        <Loading />
        <Typography variant="p" className="text-textSecondary text-center">
          Redirecting to code sign-in...
        </Typography>
      </div>
    </CommonAuthLayout>
  );
};

export default ResetPassword;
